<!----
    Author: hjlee
    Description:
        노출 컨트롤
---->
<template>
  <div v-show="isVisibleControl()" :class="{'display-control': true, 'detail-display-control': mode === 'detail'}">
    <label
      v-if="mode === 'detail' && !noTitle && (type !== 'checkbox' || (checkboxLabel && $t(checkboxLabel) !== title))"
      :for="modalName + '-' + name"
      :class="{'checkbox-class': type === 'checkbox'}"
    >{{ title ? title : $t(modalName + '.label.' + name) }}</label>
    <label
      v-else-if="
        mode===
          'detail'
          &&
          type===
          'checkbox'
          &&
          $t(checkboxLabel)===
          title"
      :class="{'checkbox-class': type === 'checkbox'}"
    >&nbsp;</label>

    <span :class="{'contents-area': true, 'detail-contents-area': mode === 'detail', 'no-file-contents': fileInfo && (!contents || contents.length === 0), 'checkbox-class': type === 'checkbox'}">
      <span v-if="fileInfo">
        <span v-if="mode === 'list'" class="file-data-area">
          <span v-if="contents && contents.length > 1" class="file-count">
            {{ $t('file.text.file_count', { cnt : contents.length }) }}
          </span>
          <span v-for="(file, fileIndex) in contents" :key="fileIndex" :class="['file-preview-on-list', fileInfo.usePrimary ? 'use-primary' : '', (file.primaryFlag === 'Y')?'primary':'']">
            <file-preview v-if="fileIndex < 5" :file="file" :width="40" :name="file.fileNm" scale="small" />
          </span>
          <span v-if="!contents || (contents.length === 0)" :class="['file-preview-on-list', fileInfo.usePrimary ? 'use-primary' : '', 'primary']">
            <span v-if="isImagePurpose(fileInfo.purpose)">
              <b-img class="default-thumb-image" :src="'/img/' + fileInfo.defaultImage" :alt="$t('file.alt.default_image')" />
            </span>
          </span>
        </span>
        <span v-else>
          <span v-if="contents && (contents.length > 0)" class="preview-area">
            <image-slider3d v-if="isImagePurpose(fileInfo.purpose)" :contents="contents" :use-primary="fileInfo.usePrimary" />
            <span v-else>
              <span v-for="(file, fileIndex) in contents" :key="fileIndex">
                <a class="clickable" @click="downloadFileWithTmpId(file.tmpId, file.fileNm, file)">
                  <file-icon :filename="file.fileNm" scale="extra-small" />
                  {{ file.fileNm }}
                  <span class="download-count">
                    <i class="fa fa-download" /> {{ file.dwldCo }}
                  </span>
                </a>
              </span>
            </span>
          </span>
          <span v-else>
            <span v-if="isImagePurpose(fileInfo.purpose)">
              <b-img thumbnail class="default-thumb-image" :src="'/img/' + (fileInfo.defaultImage ? fileInfo.defaultImage : 'thumb/defaultPicture.png')" :alt="$t('file.alt.default_image')" />
            </span>
            <span v-else>
              {{ $t('file.text.no_file') }}
            </span>
          </span>
        </span>
      </span>
      <div v-else-if="type === 'hierarchy_select'">
        <hierarchy-selector
          v-model="contents"
          :fetching-children-url="fetchingChildrenUrl"
          :get-initial-value-url="getInitialValueUrl"
          :disabled="true"
        />
      </div>
      <span v-else-if="textInfos && textInfos.length > 0">{{ value }}</span>
      <div v-else-if="type === 'html_editor'" :class="{'html-contents-area': true, 'ql-editor': true, 'ql-container': true, 'detail-html-contents-area': mode === 'detail'}" v-html="contents" />
      <div v-else-if="type === 'color'" class="color-area" :style="'background-color: ' + contents + ';'" />
      <div v-else-if="type === 'creditcard'" class="creditcard-area">
        <credit-card v-model="value" :readonly="true" />
      </div>
      <div v-else-if="type === 'icon'">
        <i :class="'nav-icon fa fa-' + contents" />
      </div>
      <div v-else-if="type === 'price'">
        {{ contents | currency(visibleData?visibleData.currency:'KRW') }}
      </div>
      <div v-else-if="type === 'point'">
        {{ contents | point($t('point.text.unit'), $t('point.text.position')) }}
      </div>
      <div v-else-if="type === 'date' || name.endsWith('De') || name.endsWith('Bgnde') || name.endsWith('Endde')">
        {{ getDateString(contents) }}
      </div>
      <div v-else-if="type === 'datetime' || name.endsWith('Dt')">
        {{ getDatetimeString(contents) }}
      </div>
      <div v-else-if="type === 'video'">
        {{ contents }}
        <div v-if="typeCodeFieldName && (visibleData[typeCodeFieldName] === 'video_type.vimeo')">
          <my-vimeo-player v-if="playerWidth" :video-id="contents" :player-width="playerWidth" @error="onVimeoError" />
          <b-alert
            :show="!!vimeoError"
            variant="warning"
          >
            {{ vimeoError }}
          </b-alert>
        </div>
        <div v-else-if="typeCodeFieldName && (visibleData[typeCodeFieldName] === 'video_type.youtube')">
          <my-youtube-player v-if="playerWidth" :video-id="contents" :player-width="playerWidth" @error="onYoutubeError" />
          <b-alert
            :show="!!youtubeError"
            variant="warning"
          >
            {{ youtubeError }}
          </b-alert>
        </div>
      </div>
      <div v-else-if="type === 'i18n'">
        <div v-if="Array.isArray(contents)">
          <div v-for="(content, contentIndex) in contents" :key="contentIndex">
            {{ $t('locale.nm.' + getLocale(content)) }} : {{ $t(content.code, {}, getLocale(content)) }}
          </div>
        </div>
        <div v-else>
          {{ contents }}
        </div>
      </div>
      <div v-else-if="type === 'map'">
        <global-map
          v-model="contents"
          :readonly="true"
          :auto-search-location="false"
        />
      </div>
      <div v-else-if="isHtml && type === 'multiselect'" v-html="value" />
      <div v-else-if="isHtml && type === 'multiselect_list'" v-html="value" />
      <div v-else-if="type === 'multiselect'">
        {{ value }}
      </div>
      <div v-else-if="type === 'multiselect_list'">
        {{ value }}
      </div>
      <div v-else-if="type === 'name'">
        {{ getName(value) }}
      </div>
      <pre v-else-if="type === 'textarea'">{{ contents?contents.trim():'' }}</pre>
      <div v-else-if="type === 'inhabitants_identification_number'">
        {{ value | formatInhabitantsIdentificationNumber }}
      </div>
      <div v-else-if="type === 'juridical_registration_number'">
        {{ value | formatJuridicalRegistrationNumber }}
      </div>
      <div v-else-if="type === 'checkbox'">
        <span v-if="checkboxLabel">{{ $t(checkboxLabel) }} : </span>
        {{ value ? value : 'N' }}
      </div>
      <div v-else-if="type === 'business_registration_number'">
        {{ value | formatBusinessRegistrationNumber }}
      </div>
      <div v-else-if="type === 'tel' && (configs.only_for_korea_republic_of === 'true' || staticLocale === 'ko_kr')">
        {{ value | formatKoreanTel }}
      </div>
      <span v-else-if="options && options.length > 0 && name.endsWith('Code')">{{ contents ? $t('code.nm.' + contents) : '' }}</span>
      <span v-else-if="isInnerColumn">{{ value }}</span>
      <span v-else-if="isHtml" v-html="contents" />
      <span v-else>{{ contents }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    modalName: {
      type: String,
      default: 'common'
    },
    title: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'detail'
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    checkboxLabel: {
      /* 체크박스 라벨. 라벨이 있는 경우 타이틀을 따로 표시한다. */
      type: String,
      default: ''
    },
    fetchingChildrenUrl: {
      type: String,
      default: ''
    },
    getInitialValueUrl: {
      type: String,
      default: ''
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    nodeDepth: {
      type: Number,
      default: 0
    },
    staticLocale: {
      type: String,
      default: ''
    },
    staticCurrency: {
      type: String,
      default: ''
    },
    typeCodeFieldName: {
      type: String,
      default: ''
    },
    isHtml: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    noDataLabelTextCode: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: undefined
    },
    targetType: {
      type: String,
      default: undefined
    },
    fileInfo: {
      type: Object,
      default: undefined
    },
    contents: {
      type: null,
      default: undefined
    },
    visibleData: {
      type: Object,
      default: undefined
    },
    visibleBy: {
      type: Array,
      default: undefined
    },
    visibleType: {
      type: String,
      default: ''
    },
    textInfos: {
      type: Array,
      default: undefined
    },
    separatorTextInfos: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: undefined
    },
    masterSelectedRow: {
      type: Object,
      default: undefined
    },
    inSection: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      vimeoError: undefined,
      youtubeError: undefined,
      dateConfig: {
        format: this.$t('common.format.date')
      },
      datetimeConfig: {
        format: this.$t('common.format.datetime')
      },
      value: undefined,
      playerWidth: undefined,
      isInnerColumn: false
    }
  },
  mounted() {
    if (this.textInfos) {
      let contents = this.visibleData
      if (this.inSection) {
        contents = this.contents
      }
      this.value = this.getTextFromTextInfos(
        this.textInfos,
        contents,
        this.name,
        this.separatorTextInfos,
        this.targetType,
        this.noDataLabelTextCode,
        this.inSection
      ).stripTags()
    } else if (this.type === 'multiselect') {
      if (typeof this.contents === typeof '') {
        this.value = this.contents
      } else if (this.options) {
        for (let i = 0; i < this.options.length; i++) {
          if (this.contents) {
            const option = this.options[i]

            for (let j = 0; j < this.contents.length; j++) {
              const content = this.contents[j]
              if (option.value === content[this.valueKey]) {
                if (this.value) {
                  this.value += ', '
                } else {
                  this.value = ''
                }
                this.value += option.text
              }
            }
          }
        }
      }
    } else if (this.type === 'multiselect_list') {
      if (typeof this.contents === typeof '') {
        this.value = this.contents
      } else if (this.options) {
        for (let i = 0; i < this.options.length; i++) {
          if (this.contents) {
            const option = this.options[i]

            for (let j = 0; j < this.contents.length; j++) {
              const content = this.contents[j]
              if (option.value === content) {
                if (this.value) {
                  this.value += ', '
                } else {
                  this.value = ''
                }
                this.value += option.text
              }
            }
          }
        }
      }
    } else if (this.name && this.name.indexOf('.') >= 0 && this.visibleData) {
      const keys = this.name.split('.')
      this.value = this.visibleData
      for (let i = 0; i < keys.length; i++) {
        this.value = this.value[keys[i]]
        if (!this.value) {
          this.value = '-'
          break
        }
      }
      this.isInnerColumn = true
    } else {
      this.value = this.contents
    }
    this.playerWidth = $(this.$el).width()
  },
  methods: {
    getName(encoded) {
      if (!encoded) {
        return ''
      }
      const names = encoded.split(';')
      let ret = ''
      for (let i = 0; i < names.length; i++) {
        if (ret) {
          ret += ' '
        }
        ret += decodeURIComponent(names[i])
      }
      return ret
    },
    onVimeoError(vimeoError) {
      this.vimeoError = vimeoError
    },
    onYoutubeError(youtubeError) {
      this.youtubeError = youtubeError
    },
    getLocale(content) {
      if (!content) {
        return
      }
      if (content.locale && content.locale.locale) {
        return content.locale.locale
      }
      return content.locale
    },
    getDatetimeString(value) {
      if (!value) {
        return ''
      }
      if (isNaN(value)) {
        return value
      }
      return this.$moment(parseInt(value)).format(
        this.$t('common.format.datetime')
      )
    },
    getDateString(value) {
      if (!value) {
        return ''
      }
      if (isNaN(value)) {
        return value
      }
      return this.$moment(parseInt(value)).format(this.$t('common.format.date'))
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  width: 120px;
  float: left;
}
.checkbox-class {
  float: none !important;
  width: auto !important;
}

.color-area {
  width: 100px;
  height: 35px;
  max-width: 100%;
}

.detail-display-control {
  overflow: hidden;
  margin-bottom: 20px;
}

.thumb-image-area img {
  width: 100px;
}

.preview-area {
  width: 300px;
  height: 240px;
}
.detail-contents-area {
  width: calc(100% - 120px);
  float: left;
}
.detail-contents-area.no-file-contents {
  background-color: #e4e5e6;
  border: 1px solid #c8ced3;
  text-align: center;
  margin: 20px auto;
}
.detail-contents-area.no-file-contents .img-thumbnail {
  background: transparent;
  border: none;
}
.detail-html-contents-area {
  border: 1px solid #aaaaaa;
  border-radius: 10px;
  padding: 15px;
}
>>> ol.carousel-indicators {
  background-color: rgba(0, 0, 0, 0.4);
}
>>> iframe {
  max-width: 100%;
}
.file-data-area:hover .file-count {
  display: block;
}

.file-preview-on-list {
  width: 40px;
  height: 40px;
  overflow: hidden;
  margin-top: -10px;
  margin-bottom: -10px;
}

.file-preview-on-list img {
  width: 40px;
}

.file-preview-on-list {
  float: left;
}

.file-preview-on-list.use-primary {
  margin-left: auto;
  margin-right: auto;
  display: none;
  float: none;
}

.file-preview-on-list.use-primary.primary {
  display: block;
}

.file-count {
  color: white;
  background-color: rgba(0, 0, 0, 0.5);
  margin-bottom: -21px;
  padding: 5px 10px;
  border-radius: 10px;
  display: none;
  position: absolute;
  font-size: 0.7rem;
}
</style>
